/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, {useEffect, useContext, useState} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoginForm from '../../components/loginForm';

import AppStateContext from "../../context/appStateContext";
import GetSiteInfo from "../../../functions/GetSiteInfo";
import APIHelper from "../../../hooks/useAPIHelper";

import {
  AngledBackground,
  Background,
  ContentCtn,
  FooterCtn,
  FormContainer,
  LoginPage,
  LogoImg,
  LogoImgCtn,
  Spacer,
  WelcomeText,
} from './index.style';

import footer from '../../../assets/images/hegLogo/logo.png';

const Login: React.FC<any> = (): React.ReactElement => {
  const { setAppStateDetails } = useContext(AppStateContext);
  const [ siteLogo, setSiteLogo ] = useState('');
  const [ siteBackground, setSiteBackground ] = useState('');
  const getSiteInfo = APIHelper();

  const siteInfoCallback = (data: {
    contact_email: {text: string}[],
    call_time: {text: string}[],
    default_number: {text: string}[],
    primary_logos: [],
    secondary_logos: [],
    small_logos: [],
    background_image: [],
    sharepoint_link: {url: string},
  }) => {
    setAppStateDetails({
      siteLogo: {
        primary_logos: data.primary_logos,
        secondary_logos: data.secondary_logos,
        small_logos: data.small_logos,
        background_image: data.background_image,
      },
      contactEmail: data.contact_email[0].text,
      sharepointLink: data.sharepoint_link.url,
      callTime: data.call_time[0].text,
      defaultNumber: data.default_number[0].text,
    });
    setSiteLogo(data['primary_logos'][1]['image']['url']);
    setSiteBackground(data['background_image'][0]['image']['url']);
  };

  useEffect(() => {
    getSiteInfo.run(GetSiteInfo, siteInfoCallback, []);
  },[]);

  return (
    <LoginPage>
      <Background background={siteBackground}>
        <Spacer />
        <ContentCtn>
          <WelcomeText>Welcome to our Client Portal</WelcomeText>
          <LogoImgCtn>
            <LogoImg src={siteLogo} alt="Aquaheat logo" />
          </LogoImgCtn>
          <FormContainer>
            <LoginForm />
          </FormContainer>
          <FooterCtn>
            <img src={footer} alt="HEG logo" />
          </FooterCtn>
        </ContentCtn>
        <AngledBackground xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <polygon fill="#f9fbfc" points="0,0 0,100 100,100" />
        </AngledBackground>
      </Background>
    </LoginPage>
  );
};

export default Login;
